import React from 'react';
import { useStore } from '@hooks';
import { observer } from 'mobx-react';
import BigCommerce from './components/BigCommerce';
import Shopify from './components/Shopify';

const Welcome = observer(() => {
    const store = useStore();
    const { embeddedLoadPayload } = store.authStore;

    if (embeddedLoadPayload?.shop) {
        return <Shopify />;
    }

    return <BigCommerce />;
});

export default Welcome;
